/**
 * @desc 收款
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.PaymentDepositRecordsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/payment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
